import React, { PropsWithChildren, Dispatch, SetStateAction } from 'react'

type THelpMessageContext = {
  helpMessage: string
  setHelpMessage: Dispatch<SetStateAction<string>>
}

const HelpMessageContext = React.createContext<THelpMessageContext>({
  helpMessage: '',
  setHelpMessage: () => null,
})

export function useHelpMessage() {
  return React.useContext(HelpMessageContext)
}

export default function HelpMessageProvider({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  const [helpMessage, setHelpMessage] = React.useState<string>('')

  return (
    <HelpMessageContext.Provider
      value={{
        helpMessage,
        setHelpMessage,
      }}
    >
      {children}
    </HelpMessageContext.Provider>
  )
}
